module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-1.bb165161.jpg";